// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PFileUnknownOutlinedSvg from "@fishx/icons-svg/es/asn/PFileUnknownOutlined";
import FishxIcon from '../components/FishxIcon';

var PFileUnknownOutlined = function PFileUnknownOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PFileUnknownOutlinedSvg
  }));
};

PFileUnknownOutlined.displayName = 'PFileUnknownOutlined';
export default React.forwardRef(PFileUnknownOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PFileUnknownOutlined.js
// module id = 3410
// module chunks = 0